export default __webpack_public_path__ + "static/media/cover10.06e10c1c.jpeg";